import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface ReportJobQuote {
    loading: boolean;
    systemCompanyId: number;
    startDate: string;
    endDate: string;
    errors: any;
}

export class ReportJobQuoteData extends React.Component<RouteComponentProps<{}>, ReportJobQuote> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            systemCompanyId: 2,
            startDate: "",
            endDate: "",
            errors: {}
        }  
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunReports&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                axios.get('api/User/GetUserSystemCompanyId?SubId=' + user.sub, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    this.setState({ loading: false, systemCompanyId: res.data });
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else if (res.data == false) {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = "";
        this.setState(change);
    }

    validate = () => {
        let fields = this.state;
        let errors: any = {};
        let formIsValid = true;

        if (!fields.startDate) {
            formIsValid = false;
            errors["startDate"] = "Start Date is required";
        }

        if (!fields.endDate) {
            formIsValid = false;
            errors["endDate"] = "End Date is required";
        }

        if (fields.startDate && fields.endDate && fields.endDate < fields.startDate) {
            formIsValid = false;
            errors["startDate"] = "Start Date must be < End Date";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data

        if (this.validate()) {
            this.runRpt();
        }
    }

    async runRpt() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios('api/Report/RunJobQuoteReport?StartDate=' + this.state.startDate + "&EndDate=" + this.state.endDate + "&subId=" + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            var filename = this.state.systemCompanyId === 3 ? "Job Orders.xlsx" : "Job Quotes.xlsx";

            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {

        return (
            <div>
                <div>
                    <h1>Job {this.state.systemCompanyId === 3 ? "Order" : "Quote"} by Product/Item Report</h1>
                </div>
                <div className="marginTop20">
                    <div>Gets all products/items {this.state.systemCompanyId === 3 ? "created" : "quoted"} between start date and end date</div>
                    <span>Select a Start Date and End Date to run the report. </span>
                </div>
                <div>
                    <label className="input-group" htmlFor="startDate">
                        <span className="label">Start Date</span>
                        <input type='date' id="startDate" name="startDate" className='input' value={this.state.startDate} onChange={(e) => this.handleChange(e)}></input>
                    </label>
                    <span className={this.state.errors["startDate"] ? "label errors marginLeftLabel" : "hidden"}>{this.state.errors["startDate"]}</span>

                    <label className="input-group" htmlFor="endDate">
                        <span className="label">End Date</span>
                        <input type='date' id="endDate" name="endDate" className='input' value={this.state.endDate} onChange={(e) => this.handleChange(e)}></input>
                    </label>
                    <span className={this.state.errors["endDate"] ? "label errors marginLeftLabel" : "hidden"}>{this.state.errors["endDate"]}</span> 
                </div>
                <button className="defaultbutton marginLeftLabel" type='button' onClick={this.runReport}>Run Report</button>
            </div>
        );

    }

};